/* Desktop Dynamic search script */
(function(){
    var mode = 'desktop';

    /* Desktop element */
    var desktop_clip_container = document.getElementById('deskeop-search-outer-container');
    var search_input = document.getElementById('desktop-search-input');
    var search_results_conainer = document.getElementById('desktop-search-results-container');
    var sections = {};
    sections.products = document.getElementById('desktop-search-results-product');
    sections.pages = document.getElementById('desktop-search-results-pages');
    sections.articles = document.getElementById('desktop-search-results-articles');

    var results = {};
    results.products = document.getElementById('desktop-search-results-list-product');
    results.pages = document.getElementById('desktop-search-results-list-pages');
    results.articles = document.getElementById('desktop-search-results-list-articles');

    /* Mobile elements */
    var mobile_clip_container = document.getElementById('mobile-search-outer-container');
    var mobile_search_input = document.getElementById('mobile-search-activate');
    var mobile_menu_state = document.getElementById('mobile-menu-toggle');
    var mobile_popup_state = document.getElementById('mobile-search-toggle');
    var mobile_search_link = document.getElementById('mobile-search-activate');
    var mobile_search_input = document.getElementById('mobile-search-input');
    var mobile_search_results_container = document.getElementById('mobile-search-results-container');

    var mobile_sections = {};
    mobile_sections.products = document.getElementById('mobile-search-results-product');
    mobile_sections.pages = document.getElementById('mobile-search-results-pages');
    mobile_sections.articles = document.getElementById('mobile-search-results-articles');

    var mobile_results = {};
    mobile_results.products = document.getElementById('mobile-search-results-list-product');
    mobile_results.pages = document.getElementById('mobile-search-results-list-pages');
    mobile_results.articles = document.getElementById('mobile-search-results-list-articles');

    /* section subheaders */
    var section_headings = document.querySelectorAll('.search-results-section__header');

    function hide_sections(s) {
        s.products.style['display'] = 'none';
        s.pages.style['display'] = 'none';
        s.articles.style['display'] = 'none';
    }

    function hide_headers() {
        for (var i = 0; i < section_headings.length; i++) {
            section_headings[i].style.display = 'none';
        }
    }

    function show_headers() {
        for (var i = 0; i < section_headings.length; i++) {
            section_headings[i].style.display = 'block';
        }
    }

    function clear_results(r) {
        r.products.innerHTML = '';
        r.pages.innerHTML = '';
        r.articles.innerHTML = '';
        desktop_clip_container.style['height'] = "13.5rem";
        mobile_clip_container.style['height'] = "14.38rem";
    }

    function search_reset() {
        search_results_conainer.style['display'] = 'none';
        hide_sections(sections);
        clear_results(results);
        hide_sections(mobile_sections);
        clear_results(mobile_results);
        search_input.value = '';
        mobile_search_input.value = '';
        search_input.focus();
    }

    function filter_broken(url) {
        if (url.indexOf('-1/') === -1) {
            return false;
        }
        return true;
    }

    function result_length_good(rs) {
        var c = 0;
        for (var i = 0; i < rs.length; i++) {
            if (!filter_broken(rs[i].url)) {
                c += 1;
            }
        }
        return c;
    }

    function render_results_section(el_container, results) {
        for (var i = 0; i < results.length; i++) {
            var el_link = document.createElement('A');
            //if (!filter_broken(results[i].url)) {
                el_link.classList.add('search-result__link');
                el_link.href = results[i].url;
                el_link.text = filter_product_name(results[i].title);
                var el_result_container = document.createElement('DIV');
                el_result_container.classList.add('search-result__container');
                el_result_container.appendChild(el_link);
                el_container.appendChild(el_result_container);
            //}
        }
    }

    function filter_product_name(s) {
        /* Remove html in product names */
        s = s.replace('</br>', ' ');
        s = s.replace('<span>', '');
        s = s.replace('</span>', '');
        return s;
    }

    function render_results(r, sections_containers, results_containers) {
        hide_headers();
        var section_count = 0;
        if (mode == 'desktop') {
            hide_sections(sections);
            clear_results(results);
            desktop_clip_container.style['height'] = "100rem";
        }
        else {
            hide_sections(mobile_sections);
            clear_results(mobile_results);
            mobile_clip_container.style['height'] = "80rem";
        }

        var is_results = false;
        if (
            r.resources.results.hasOwnProperty('products')
            && r.resources.results.products.length > 0
        ) {
            is_results = true;
            section_count += 1;
            sections_containers.products.style['display'] = 'block';
            if (mode == 'desktop') {
                render_results_section(results.products, r.resources.results.products);
            }
            else {
                render_results_section(mobile_results.products, r.resources.results.products);
            }
        }

        if (
            r.resources.results.hasOwnProperty('pages')
            && r.resources.results.pages.length > 0
        ) {
            is_results = true;
            section_count += 1;
            sections_containers.pages.style['display'] = 'block';
            if (mode == 'desktop') {
                render_results_section(results.pages, r.resources.results.pages);
            }
            else {
                render_results_section(mobile_results.pages, r.resources.results.pages);
            }
        }

        if (
            r.resources.results.hasOwnProperty('articles')
            && r.resources.results.articles.length > 0
            /*&& result_length_good(r.resources.results.articles) > 0*/
        ) {
            is_results = true;
            section_count += 1;
            sections_containers.articles.style['display'] = 'block';
            if (mode == 'desktop') {
                render_results_section(results.articles, r.resources.results.articles);
            }
            else {
                render_results_section(mobile_results.articles, r.resources.results.articles);
            }
        }

        if (is_results && mode == 'desktop') {
            search_results_conainer.style['display'] = 'block';
        }
        if (is_results && mode == 'mobile') {
            mobile_search_results_container.style['display'] = 'block';
        }

        if (section_count > 1) {
            show_headers();
        }
    }

    function in_array(key, a) {
        for (var i = 0; i < a.length; i++) {
            if (a[i].toLowerCase() == key.toLowerCase()) return true;
        }
        return false;
    }

    function do_search(term) {
        var url = "/search/suggest.json?q=" + term + "&resources[type]=product,article,page&fields=title,body,author";
        var xmlHttp = new XMLHttpRequest();
        xmlHttp.onreadystatechange = function() {
            if (xmlHttp.readyState == 4 && xmlHttp.status == 200) {
                if (mode == 'desktop') {
                    render_results(JSON.parse(xmlHttp.responseText), sections, results);
                }
                else {
                    render_results(JSON.parse(xmlHttp.responseText), mobile_sections, mobile_results);
                }
            }
        }
        xmlHttp.open("GET", url, true);
        xmlHttp.send(null);
    }

    function search_term_changed(e) {
        mode = 'desktop';
        do_search(search_input.value);
    }

    search_input.addEventListener('keyup', search_term_changed);
    document.getElementById('desktop-search-state').addEventListener('change', search_reset);
    search_results_conainer.style['display'] = 'none';

    /* Mobile event handlers */
    function mobile_search_clicked(e) {
        mode = 'mobile';
        mobile_menu_state.checked = false;
        window.scrollTo(0, 0);
        mobile_popup_state.checked = true;
        mobile_search_input.focus();
        mobile_search_input.value = '';
        mobile_search_results_container.style['display'] = 'none';
    }

    function mobile_search_close_clicked(e) {
        search_reset();
        mobile_search_results_container.style['display'] = 'none';
        mobile_popup_state.checked = false;
    }

    function mobile_serch_input_changed(e) {
        mode = 'mobile';
        do_search(mobile_search_input.value);
    }

    mobile_search_link.addEventListener('click', mobile_search_clicked);
    document.getElementById('mobile-search-close').addEventListener('click', mobile_search_close_clicked);
    mobile_search_input.addEventListener('keyup', mobile_serch_input_changed);
    mobile_search_results_container.addEventListener('click', dont_bubble);

    /* Close on outside click */
    var search_show_state = document.getElementById('desktop-search-state');
    var search_activation = document.getElementById('desktop-search-link');
    var opening = true;
    function on_outside_click(e) {
        if (opening) {
            opening = false;
            return;
        }
        if (mode == 'desktop' && search_show_state.checked == true) {
            search_show_state.checked = false;
            search_reset();
        }
        else if(mobile_popup_state.checked == true) {
            mobile_popup_state.checked = false;
            mobile_search_results_container.style['display'] = 'none';
            search_reset();
        }
    }
    document.addEventListener('click', on_outside_click);
    function dont_bubble(e) {
        e.stopPropagation();
    }
    function activating() {
        opening = true;
    }
    search_activation.addEventListener('click', activating);
    search_activation.addEventListener('click', dont_bubble);
    document.getElementById('desktop-search-container').addEventListener('click', dont_bubble);
    document.addEventListener('click', on_outside_click);
})();
